import { Box } from '@mui/material';
import React from 'react';
import { Hero } from '../Components/Hero';

export function AboutPage() {
    return (
        <Box
            sx={{
                minHeight: '100%',
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <Box sx={{ width: '100%' }}>
                <Hero />
            </Box>
        </Box>
    )
}
